module.exports = class {
    onCreate() {
        this.MAX_LINE = 5; // the number of line (bar) to be shown
        this.CONTAINER_PADDING = 28; // the total padding (top padding + bottom padding). Used to calculate how many lines can fit.
        this.LINE_HEIGHT = 27; // the height of the line (bar).
        this.state = {
            style: '',
            totalLine: 0,
        };
    }

    onInput(input) {
        this.state.style = '';
        this.state.totalLine = 0;

        if (input.width <= 0 || !input.height || input.height <= 0) {
            return;
        }

        this.state.style = `${input.width ? `width:${input.width}px;` : ''}height:${input.height}px;`;
        // Calculate how many lines to be shown, maximum line of 5
        this.state.totalLine = Math.min(this.MAX_LINE, Math.floor((input.height - this.CONTAINER_PADDING) / this.LINE_HEIGHT));
    }
};
